module.exports = __webpack_public_path__ + "img/bengalis-DE.4537cc27.png";